/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FiscalYearStartMonthEnum } from './fiscalYearStartMonthEnum';


/**
 * Project timeframe
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectTimeframe { 
    /**
     * Project start date
     */
    startDate?: string;
    /**
     * Project end date (expected)
     */
    endDate?: string;
    /**
     * Work plan start date
     */
    workPlanStartDate?: string | null;
    /**
     * Work plan end date
     */
    workPlanEndDate?: string | null;
    fiscalYearStartMonth?: FiscalYearStartMonthEnum;
    /**
     * Whether timeframe supports quarters or not
     */
    supportsQuarters?: boolean;
    /**
     * Whether timeframe supports days or not
     */
    supportsDays?: boolean;

    constructor(item?: Partial<ProjectTimeframe>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            startDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.startDate : itemOrValue;

                    if (itemOrValue?.startDate != null) {
                        if (itemOrValue.startDate === '') {
                            itemOrValue.startDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.startDate = parseInt(itemOrValue.startDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.startDate = parseFloat(itemOrValue.startDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            endDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.endDate : itemOrValue;

                    if (itemOrValue?.endDate != null) {
                        if (itemOrValue.endDate === '') {
                            itemOrValue.endDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.endDate = parseInt(itemOrValue.endDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.endDate = parseFloat(itemOrValue.endDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            workPlanStartDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workPlanStartDate : itemOrValue;

                    if (itemOrValue?.workPlanStartDate != null) {
                        if (itemOrValue.workPlanStartDate === '') {
                            itemOrValue.workPlanStartDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.workPlanStartDate = parseInt(itemOrValue.workPlanStartDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.workPlanStartDate = parseFloat(itemOrValue.workPlanStartDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            workPlanEndDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workPlanEndDate : itemOrValue;

                    if (itemOrValue?.workPlanEndDate != null) {
                        if (itemOrValue.workPlanEndDate === '') {
                            itemOrValue.workPlanEndDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.workPlanEndDate = parseInt(itemOrValue.workPlanEndDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.workPlanEndDate = parseFloat(itemOrValue.workPlanEndDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            fiscalYearStartMonth: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.fiscalYearStartMonth : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            supportsQuarters: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.supportsQuarters : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            supportsDays: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.supportsDays : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectTimeframe.isValid,
        };
    }

    static isValid(obj: ProjectTimeframe): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectTimeframe.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.startDate.isValid(item);
            result = result && validationObject.endDate.isValid(item);
            result = result && validationObject.workPlanStartDate.isValid(item);
            result = result && validationObject.workPlanEndDate.isValid(item);
            result = result && validationObject.fiscalYearStartMonth.isValid(item);
            result = result && validationObject.supportsQuarters.isValid(item);
            result = result && validationObject.supportsDays.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

